  var currentStep = 0
  var selfBuy = false;
  var jsonArr = JSON.parse(document.querySelector("#datajson").innerHTML);
  var jsonArr2 = JSON.parse(document.querySelector("#datajson2").innerHTML);
  const nextStep = (elem, step, e) => {
    
    // console.log(e);
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('#amount-input').dispatchEvent(new Event("change"));
    currentStep = step
    if ((step == 4)) {
      
      if (!document.querySelector('#recipientEmail-input').checkValidity()) {
        document.querySelector('#recipientEmail-input').reportValidity();
      } else {        
        let addToCartForm = document.querySelector('#giftcardform');
        let formData = new FormData(addToCartForm);
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          console.log(response);
          window.location = '/cart';
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
      //Do add to cart
      return;
    }

        // for me gift 
        if(((step == 2) && selfBuy) ){
            let customer_is_login = document.querySelector('#recipientEmail-input').getAttribute('data-customer');
            if(customer_is_login){
                document.querySelector('#recipientEmail-input').value = customer_is_login
                let addToCartForm_2 = document.querySelector('#giftcardform');
                let formData_2 = new FormData(addToCartForm_2);
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData_2
                })
                .then(response => {
                    window.location = '/cart';
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
            else {
                e.preventDefault();
                
                // Use event.currentTarget to get the element that triggered the event
                let step2 = event.currentTarget.closest('.step2'); 
                let step3 = step2.nextElementSibling;
                
                step2.classList.remove('hidden');
                step3.classList.add('hidden');
        
                var errorMessage = step2.querySelector('.forMe_error');
                errorMessage.style.display = 'block';
                
            }
        }

      var checkOutOfStock =  document.querySelector('#variant_id').classList.contains('disabled')
      if(checkOutOfStock && step == 3){
         document.querySelector('.step.step4 button>span').innerHTML = 'Sold Out';
         document.querySelectorAll('.step.step4 button').forEach((button)=>{
           button.setAttribute('disabled', 'true')
         })
      }else{
          document.querySelectorAll('.step.step4 button').forEach((button)=>{
           button.removeAttribute('disabled')
         })
        document.querySelector('.step.step4 button>span').innerHTML = 'Add To Cart';
        document.querySelector('#recipientEmail-input').removeAttribute('required');
      }

    
    elem.closest('.step').classList.add('hided');
    elem.closest('.step').classList.add('hidden');
    elem.closest('.step').parentElement.querySelector('.step:not(.hided)').classList.remove('hidden');
    if (!selfBuy) {
      document.querySelector('.step.step2 .control-container button > span').innerHTML = 'Add a message.';
      document.querySelector('#recipientEmail-input').setAttribute('required', true);
    } else if (selfBuy){
     var checkOutOfStock =  document.querySelector('#variant_id').classList.contains('disabled')
      if(checkOutOfStock){
         document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Sold Out';
         document.querySelectorAll('.step.step2 .control-container button').forEach((button)=>{
           button.setAttribute('disabled', 'true')
         })
      }else{
          document.querySelectorAll('.step.step2 .control-container  button').forEach((button)=>{
           button.removeAttribute('disabled')
         })
        document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Add To Cart';
        document.querySelector('#recipientEmail-input').removeAttribute('required');

        
        // for me gift
         var step2 = event.currentTarget.closest('.step2'); 
        var step3 = step2.nextElementSibling;
        step2.classList.remove('hidden');
        step3.classList.add('hidden');
      }
 
    }else {
      document.querySelector('#recipientEmail-input').removeAttribute('required');
    }
    return false;
  }

  document.addEventListener("DOMContentLoaded", () => {

    document.getElementById('isSelfBuy-0').addEventListener('click', () => {
      selfBuy = false;
      document.getElementById('tabpanel').classList.remove('hidden');
      //document.querySelector('#senttoreceipitent').checked = true;
      document.getElementById('isSelfBuy-0').classList.add('tab--selected');
      document.getElementById('isSelfBuy-1').classList.remove('tab--selected');
    });
    
    document.getElementById('isSelfBuy-1').addEventListener('click', () => {
      selfBuy = true;
      document.getElementById('tabpanel').classList.add('hidden');
      //document.querySelector('#senttoreceipitent').checked = false;
      document.getElementById('isSelfBuy-1').classList.add('tab--selected');
      document.getElementById('isSelfBuy-0').classList.remove('tab--selected');
      
    });
    
    document.querySelectorAll('.pill').forEach(el => {
      el.addEventListener('click', (e) => {
        document.querySelectorAll('.pill').forEach(_el => {
          _el.classList.remove('pill--selected');
        })
        e.target.classList.add('pill--selected');
        let selVal = e.target.getAttribute('value');
        document.querySelector('#amount-input').value = selVal;
        triggerChangeEvt();
      })
    })

   function triggerChangeEvt(){
      //update add to cart param
      let curVal = parseInt(document.querySelector('#amount-input').value);
      let price = curVal * 100;
      let dominican;
      let variantId;
      jsonArr.forEach(item => {
        if (item.price == price) {
          dominican = item.title;
          variantId = item.id;
          if(!item.available){
            if(selfBuy && currentStep == 1){
              document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Sold Out';
                document.querySelectorAll('.step.step2 .control-container button').forEach((button)=>{
              button.setAttribute('disabled', 'true')
              })
            }
           document.querySelector('#variant_id').classList.add('disabled');
          }else{
          if(selfBuy){
           document.querySelectorAll('.step.step2 .control-container button').forEach((button)=>{
           button.removeAttribute('disabled')
           })
           document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Add To Cart';
          }
         document.querySelector('#variant_id').classList.remove('disabled');
          }
          document.querySelector('#denominations').value = dominican;
          document.querySelector('#variant_id').value = variantId;
          document.querySelector('input[name="product-id"]').value = document.querySelector('#product2').value;
        }
      });
     
      jsonArr2.forEach(item => {
        if (item.price == price) {
          dominican = item.title;
          variantId = item.id;
          if(!item.available){
            if(selfBuy && currentStep == 1){
              document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Sold Out';
                document.querySelectorAll('.step.step2 .control-container button').forEach((button)=>{
              button.setAttribute('disabled', 'true')
              })
            }
           document.querySelector('#variant_id').classList.add('disabled');
          }else{
          if(selfBuy){
           document.querySelectorAll('.step.step2 .control-container button').forEach((button)=>{
           button.removeAttribute('disabled')
           })
           document.querySelector('.step.step2 .control-container button>span').innerHTML = 'Add To Cart';
          }
         document.querySelector('#variant_id').classList.remove('disabled');
          }
          document.querySelector('#denominations').value = dominican;
         document.querySelector('#variant_id').value = variantId;
          document.querySelector('input[name="product-id"]').value = document.querySelector('#product2').value;
          
        }
      })
    }

    document.querySelector('#amount-input').addEventListener('change', () => {
      let curVal = document.querySelector('#amount-input').value;
      if (curVal < 5) {
        curVal = 5;
      }
      if (curVal > 1000) {
        curVal = 1000;
      }
      let newVal = Math.ceil(curVal / 5) * 5;
      document.querySelectorAll('.pill').forEach(_el => {
        if (parseInt(_el.getAttribute('value')) == curVal) {
          _el.classList.add('pill--selected');
        } else {
          _el.classList.remove('pill--selected');
        }
      })
      document.querySelector('#amount-input').value = newVal;
      triggerChangeEvt();
    })

    document.querySelector('#amount-decrement-button-button').addEventListener('click', () => {
      let curVal = parseInt(document.querySelector('#amount-input').value);
      curVal -= 5;
      document.querySelector('#amount-input').value = curVal;
      triggerChangeEvt();
      document.querySelector('#amount-input').dispatchEvent(new Event("change"));
    })

    document.querySelector('#amount-increment-button-button').addEventListener('click', () => {
      let curVal = parseInt(document.querySelector('#amount-input').value);
      curVal += 5;
      document.querySelector('#amount-input').value = curVal;
      triggerChangeEvt();
      document.querySelector('#amount-input').dispatchEvent(new Event("change"));
    })

    document.querySelector('#quantity-input').addEventListener('change', () => {
      let curVal = document.querySelector('#quantity-input').value;
      if (curVal < 1) {
        curVal = 1;
      }
      document.querySelector('#quantity-input').value = curVal;
    })

    document.querySelector('#qty-decrement-button-button').addEventListener('click', () => {
      let curVal = parseInt(document.querySelector('#quantity-input').value);
      curVal -= 1;
      document.querySelector('#quantity-input').value = curVal;
      document.querySelector('#quantity-input').dispatchEvent(new Event("change"));
    })

    document.querySelector('#qty-increment-button-button').addEventListener('click', () => {
      let curVal = parseInt(document.querySelector('#quantity-input').value);
      curVal += 1;
      document.querySelector('#quantity-input').value = curVal;
      document.querySelector('#quantity-input').dispatchEvent(new Event("change"));
    })
    
    document.querySelectorAll('.radio-button').forEach(el => {
      el.addEventListener('click', (evt) => {
        document.querySelectorAll('.radio-button').forEach(_el => {
          _el.classList.remove('selected');
        })
        evt.target.classList.add('selected');
        document.querySelector('#message-input').value = evt.target.querySelector('div[id^=message-]').innerHTML;
      })
    })

    document.querySelector('#message-collapsed-link-button-button').addEventListener('click', () => {
      document.querySelector('.content-some-idea').classList.remove('hidden');
      document.querySelector('.content-get-inspire').classList.add('hidden');
    })

    document.querySelector('#message-inspiration-expanded-button-button').addEventListener('click', () => {
      document.querySelector('.content-some-idea').classList.add('hidden');
      document.querySelector('.content-get-inspire').classList.remove('hidden');
    })
    
  });